import { cva } from "class-variance-authority";

export const breadcrumbContainer = cva("flex justify-between gap-2 w-full max-w-[944px] pb-10");

export const breadcrumbLabel = cva(
  "breadcrumb",
  {
    variants: {
      status: {
        completed: "completed cursor-pointer hover:opacity-90",
        active: "active",
        inactive: "inactive",
      },
    },
  }
);
